const mutations = {
  addDataDashboard: (state, payload) => {
    state.dataDashboard = payload;
  },
  userEpayByID: (state, payload) => {
    state.dataUserEpay = payload;
  },

  setListSnapTransaksi: (state, payload) => {
    state.listSnapTransaksi = state.listSnapTransaksi.concat(payload);
  },

  setJumlahMesin: (state, payload) => {
    let count = 0
    payload.forEach(element => {
      if (element.snap_transaksi_detail[0].status != 4) {
        count++
      }
    });
    state.mesinBerjalan = count;
  },

  setDataOutlet: (state, payload) => {
    state.dataOutlet = payload;
  },
};

export default mutations;
